import Vue from 'vue'
import VueRouter from 'vue-router'
import appContent from '@/components/content'

import main from '@/components/main'
import servis from '@/components/servis/servis'
import servisdetay from '@/components/servis/detay'
import matbuu from '@/components/servis/matbuu'
import stok from '@/components/servis/stok'
import islem from '@/components/servis/islem'
import konum from '@/components/servis/konum'
import cihaz from '@/components/servis/cihaz'
import tamamla from '@/components/servis/tamamla'
import sepet from '@/components/sepet'
import depo from '@/components/depo'
import hesap from '@/components/hesap'
import LoginPage from '@/components/LoginPage'
import altgrup from '@/components/cihaz/altgrup'
import altgrupdetay from '@/components/cihaz/altgrupdetay'
Vue.use(VueRouter)

  const routes = [
    {path: '/login', component: LoginPage},

    {
      path:'/',
      component:appContent,
      redirect:'/',
      children:[
    { 
      path: "/",
      component: main ,
      Name : "Home"
    },
    {
      path: '/servis',
      name: 'Servis',
      component: servis
    },
    {
      path: '/servis/:id',
      name: 'Servisdetay',
      component: servisdetay
    },
    {
      path: '/gruplama',
      name: 'altgrup',
      component: altgrup
    },
    {
      path: '/grup/:id',
      name: 'Detay',
      component: altgrupdetay
    },
    {
      path: '/cihaz/:id',
      name: 'cihaz',
      component: cihaz
    },
    {
      path: '/matbuu/:id',
      name: 'matbuu',
      component: matbuu
    },
    {
      path: '/konum/:id',
      name: 'konum',
      component: konum
    },
    {
      path: '/tamamla/:id',
      name: 'tamamla',
      component: tamamla
    },
    {
      path: '/islem/:id',
      name: 'islem',
      component: islem
    },
    {
      path: '/stok/:id',
      name: 'stok',
      component: stok
    },     
    {
      path: '/sepet',
      name: 'Sepetim',
      component: sepet
    },
    {
      path: '/depo',
      name: 'Depom',
      component: depo
    },
    {
      path: '/hesap',
      name: 'Hesabım',
      component: hesap
    }
  ]
}
];
  export const router = new VueRouter({
   //mode: "history",
    routes
  });router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('tfx');
    if (authRequired && !loggedIn) {
  
      return next({ 
        path: '/login', 
        query: { returnUrl: to.path } 
      });
    }
  
    next();
  })




// WEBPACK FOOTER //
// ./src/router/index.js